var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { CatalogProductSetLineItemType } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export let CATALOG_PRODUCT_SET_LINE_ITEM_TYPE = /*#__PURE__*/function (CATALOG_PRODUCT_SET_LINE_ITEM_TYPE) {
  CATALOG_PRODUCT_SET_LINE_ITEM_TYPE["PRODUCT_SET_LINE_ITEM_TYPE_DO_NOT_USE"] = "PRODUCT_SET_LINE_ITEM_TYPE_DO_NOT_USE";
  CATALOG_PRODUCT_SET_LINE_ITEM_TYPE["PRODUCT_SET_LINE_ITEM_TYPE_GIFT_CARD"] = "PRODUCT_SET_LINE_ITEM_TYPE_GIFT_CARD";
  return CATALOG_PRODUCT_SET_LINE_ITEM_TYPE;
}({});
let Data = (_dec = attr('boolean', {
  allowNull: true
}), _dec2 = attr('boolean', {
  allowNull: true
}), _dec3 = attr('string', {
  allowNull: true,
  enumClass: CATALOG_PRODUCT_SET_LINE_ITEM_TYPE,
  protoEnum: CatalogProductSetLineItemType
}), _dec4 = attr('boolean', {
  allowNull: true
}), _dec5 = attr('string', {
  allowNull: true
}), _dec6 = attr({
  allowNull: true
}), _dec7 = attr({
  allowNull: true
}), _dec8 = attr('number', {
  allowNull: true
}), _dec9 = attr('number', {
  allowNull: true
}), _dec10 = attr('number', {
  allowNull: true
}), _class = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "allProducts", _descriptor, this);
    _initializerDefineProperty(this, "isProductAllTokensBeenCascadeDelete", _descriptor2, this);
    _initializerDefineProperty(this, "lineItemTypes", _descriptor3, this);
    _initializerDefineProperty(this, "matchCustomAmounts", _descriptor4, this);
    _initializerDefineProperty(this, "name", _descriptor5, this);
    _initializerDefineProperty(this, "productIdsAll", _descriptor6, this);
    _initializerDefineProperty(this, "productIdsAny", _descriptor7, this);
    _initializerDefineProperty(this, "quantityExact", _descriptor8, this);
    _initializerDefineProperty(this, "quantityMin", _descriptor9, this);
    _initializerDefineProperty(this, "quantityMax", _descriptor10, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "allProducts", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isProductAllTokensBeenCascadeDelete", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "lineItemTypes", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "matchCustomAmounts", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "productIdsAll", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "productIdsAny", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "quantityExact", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "quantityMin", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "quantityMax", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };